/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */
export default {
  platform: {
    web: 'web',
    ios: 'ios',
    android: 'android',
  },
  AppflowAppId: '5338a6cf',
  model: {
    iPhone: 'iPhone',
    iPad: 'iPad',
  },
  statusBarBackgroundColorOption: {
    color: '#20232C',
  },
  permissionAlert: {
    geoLocation: {
      title: 'Allow WeatherSpork to use your location?',
      message: 'This will allow us to show your present location in Map view.',
    },
    geoLocationError: {
      title: 'Not able to access your location',
      message: 'Please make sure WeatherSpork has access to your location.',
    },
  },
};
